import Settings from './Settings';
import SettingsForm from './SettingsForm';

export { Settings, SettingsForm };

export default Settings;
